import React from "react"; // Used by Flatpickr
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/plugins/monthSelect/style.css";

import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";

export default function MonthYearPicker({ value, onChange, parseDate }) {
  return (
    <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-fullWidth MuiInput-fullWidth MuiInputBase-formControl MuiInput-formControl" style={{"fontSize": "13px"}}>
      <Flatpickr
        value={value}
        onChange={([selectedDate]) => onChange(selectedDate)}
        options={{
          parseDate: parseDate || undefined,
          plugins: [new monthSelectPlugin({
            shorthand: false, // full month names
            dateFormat: "F Y",
            altFormat: "F Y",
          })],
        }}
        className="MuiInputBase-input MuiInput-input" // match Material-UI input style
      />
    </div>
  );
}
